import { Row, Col } from 'antd';
import React, { Suspense } from 'react';
import { ChartGenderAge } from './chart-gender-age';
import { ChartPrefectureDistribution } from './chart-prefecture-distribution';
import { ChartRecommendMatch } from './chart-recommend-match';
import { ReviewAverageCard } from './review-average-card';
import { ChartFemaleNoMatchReason } from './chart-female-no-match-reason';
import { ChartMaleLikeAverage } from './chart-male-like-average';
import { SkeletonChart } from '../skeletons-user/skeleton-chart-recommend-match';
export default function UserStatisticPage() {
    return /*#__PURE__*/ React.createElement(Row, {
        gutter: [16, 16],
        className: "mb-[40px]"
    }, /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, {
            height: 460
        })
    }, /*#__PURE__*/ React.createElement(ChartGenderAge, null))), /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, {
            height: 520
        })
    }, /*#__PURE__*/ React.createElement(ChartPrefectureDistribution, null))), /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, {
            height: 380
        })
    }, /*#__PURE__*/ React.createElement(ChartRecommendMatch, null))), /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, {
            height: 380
        })
    }, /*#__PURE__*/ React.createElement(ChartFemaleNoMatchReason, null))), /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, null)
    }, /*#__PURE__*/ React.createElement(ReviewAverageCard, null))), /*#__PURE__*/ React.createElement(Col, {
        span: 24
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(SkeletonChart, null)
    }, /*#__PURE__*/ React.createElement(ChartMaleLikeAverage, null))));
}
